import React from 'react';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import trash_icon from '../../../assets/images/icons/user-dashboard/trash-icon.png';
import moment from "moment";
import CustomModalView from '../../../common/input/customModal/customModalView';
import { Navigate } from 'react-router-dom'


const PostedJobView = (props) => {
// if (localStorage.getItem("token")) {
        return (
           <>
            <div className="dashboard-body-area" style={{width: '100%'}}>
                <section className="dashboard-page-title">
                        <div className="row justify-content-md-center">

                            <div className="col-md-4 findjob-search-bar">
                                <div className="cc-searchbar" style={{width:"95%"}}>
                                    <div className="srch-fld-row">
                                        <div className="srch-fld-col" style={{width:'82%',borderRight:"0px"}}><input type="text" placeholder="Postcode" /></div>

                                        <div className="srch-fld-col srch-btn-col">
                                            <input type="submit" value="" className="form-submit-btn" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 ">
                                 <div className="form-group">
                                    <select id="inputcare" className="cc-searchbar form-control" style={{height:'59px'}}>
                                        <option>Column View</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-3 ">
                                 <div className="form-group">
                                    <select id="inputcare" className="cc-searchbar form-control" style={{height:'59px'}}>
                                        <option>Status</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                </section>
                <section className="dashboard-page-title">

                    <div className="jobs-header">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <h2>Job Posted</h2>
                                        <h5>Total Jobs {props.length} </h5>
                                        <div className="list-view" style={{marginTop:'-19px'}}>

                                            {props.list_active === 'active' ?
                                            <a href="" onClick={props.handelFormat}  className='active' ><i className="fa fa-bars"></i></a>
                                            :
                                            <a href="" onClick={props.handelFormat} ><i className="fa fa-bars"></i></a>
                                            }
                                            {props.card_active === 'active' ?
                                            <a href="" onClick={props.handelFormat} className='active' ><i className="fa fa-th-large"></i></a>
                                            :
                                            <a href="" onClick={props.handelFormat} ><i className="fa fa-th-large"></i></a>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-lg-3 pad-left-0">
                                        <select className="select">
                                            <option>View of Job</option>
                                            <option>Popular Job 1</option>
                                            <option>Popular Job 2</option>
                                            <option>Popular Job 3</option>
                                        </select>
                                    </div>
                                    <div className="col-lg-3 pad-left-0">
                                        <select className="select">
                                            <option>Sorting by</option>
                                            <option>Popular Job 1</option>
                                            <option>Popular Job 2</option>
                                            <option>Popular Job 3</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                </section>
                <div className="table-area applied-job-table">
                 {props.card ?
                                     props.job_detail.map((jobs, index) => (
                                    <div className="job-box">
                                        <a href="" onClick={(e) => props.handelcompression(jobs.id)} className="job-expand active" data-id="job-1"></a>
                                        <h2>{jobs.title}</h2>

                                        <div className="jobs-details" style={props.expand_id === jobs.id ?{display:props.expand}:{display:'none'} } id="job-1">

                                            <div className="job-requirement">
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        Job ID:
                                                    </div>
                                                    <div className="col-sm-9"><strong>{jobs.job_number}</strong></div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        PostCode:
                                                    </div>
                                                    <div className="col-sm-9"><strong>{jobs.postcode}</strong></div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        Requirement:
                                                    </div>
                                                    <div className="col-sm-9"><strong>{jobs.carer_type}</strong></div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        Shift 1:
                                                    </div>
                                                    <div className="col-sm-9"><strong>{jobs.start_shift}</strong></div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        Shift 2:
                                                    </div>
                                                    <div className="col-sm-9"><strong>{jobs.end_shift}</strong></div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        Qualification:
                                                    </div>
                                                    <div className="col-sm-9"><strong>{jobs.qualification}</strong></div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        Experience:
                                                    </div>
                                                    <div className="col-sm-9"><strong>{jobs.experience_type}</strong></div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        Language:
                                                    </div>
                                                    <div className="col-sm-9"><strong>{jobs.language_name}</strong></div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        Remuneration:
                                                </div>
                                                    <div className="col-sm-9"><strong>{jobs.renumerate}</strong></div>
                                                </div>
                                            </div>
                                            <div className="job-description">
                                                <h4>Job description</h4>
                                                <p><span className="more">{jobs.description}</span></p>
                                            </div>
                                        </div>
                                        <div className="job-date">
                                        { jobs.start_date ?
                                            <span>Start Date: {moment(jobs.start_date).format("DD-MM-YYYY")}</span>
                                        :<span>Start Date: --</span>
                                        
                                        }
                                             {/* <span>End Date: {jobs.end_date}</span> */}
                                        </div>
                                        <div className="job-view">
                                            <ul>
                                                <li><i className="fa fa-eye"></i>{" "} Views <span>{jobs.views}</span></li>
                                                <li><i className="fa fa-wpforms"></i>{" "} Applications <span>{jobs.application_count}</span></li>
                                                <li><i className="fa fa-calendar"></i>{" "}Closing Date <span>{moment(jobs.close_date).format("MMMM DD,YYYY")}</span></li>
                                            </ul>
                                        </div>

                                    </div>
                                    ))


                        :
                        <div>
                        { Object.keys(props.job_detail).length>0? 
                    <Table responsive>
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Job Number</th>
                                <th>Title</th>
                                <th>care type</th>
                                <th>Job type</th>
                                <th>Contract type</th>
                                <th>Renumerate</th>
                                <th>Closing Date</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>


                            {props.job_detail.map((jobs, index) => (
                            <tr>
                                <td>{jobs.id}</td>
                                <td>{jobs.job_number}</td>
                                <td>{jobs.title}</td>
                                <td>{jobs.carer_type}</td>
                                <td>{jobs.job_type}</td>
                                <td>{jobs.contracttype}</td>
                                <td>{jobs.renumerate}</td>
                                <td>{jobs.close_date}</td>
                                <td>{jobs.status}</td>
                                <td >
                                <a href="" onClick={(e) => props.handlepreview(jobs.id)} className="del_btn"><i style={{marginRight: '15px',color: 'black'}} class="fa fa-eye fa-lg" aria-hidden="true"></i></a>
                                 <a href="" className="del_btn" onClick={(e) => props.handledelete(jobs.id)}><img src={trash_icon} /></a>
                                 </td>
                            </tr>
                            ))}
                        </tbody>
                    </Table>:null}
                    </div>
                    }
                </div>
            </div>
            <CustomModalView
            modal_show={props.modal_show}
            authResponse = {props.authResponse}
            showCustomModal= {props.showCustomModal}
            hideCustomModal={props.hideCustomModal}
            />
        </>
        )
// } else {
//     return (
//       <Navigate to="/login" />
//     )
// }

}

export default PostedJobView;